import { Stack } from "@mui/material";

import ErrorMessage from "./ErrorMessage";
import ImportingMessage from "./ImportingMessage";
import { usePendingStatus } from "./useGetDemoData";

// ----------------------------------------------------------------------

export default function ImportingStep() {
	const { status } = usePendingStatus();

	return (
		<Stack sx={{ alignItems: "center" }}>
			{status !== "ERRORED" && <ImportingMessage />}
			{status === "ERRORED" && <ErrorMessage />}
		</Stack>
	);
}
